import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router
} from '@angular/router';
import { LoginService, User } from './services/login.service';

@Injectable({
  providedIn: 'root'
})

export class AuthGuard implements CanActivate {

  user: User | null = null;

  constructor(
    private router: Router,
    private loginService: LoginService,
  ) {

    this.loginService.userSubject.subscribe({
      next: (user: User | null) => {
        this.user = user;
      }
    });

  }

  public async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {

    if (this.user  && this.user.tokenExpire && this.user.tokenExpire*1000 > Date.now()) {
      return true;
    } else if (this.router.url !== '/login') {
      this.router.navigate(['/login']);
    }
    return false;
  }

}
